













































































import _ from 'lodash';
import Vue from 'vue';
import moment from 'moment';
import VClamp from 'vue-clamp';
import ProductState, {
  getProductStateColor,
} from '@/core/typings/enums/ProductState';
import { mapGetters } from 'vuex';
import HMTag from '@/web/components/common/HMTag';
import HMInstructorsStack from '@/web/components/common/HMInstructorsStack.vue';
import { formatDate } from '@/web/utils/format';
import MediaThumbnail from '@/web/components/products/MediaThumbnail.vue';

export default Vue.extend({
  name: 'StudioMediaCard',
  components: { VClamp, HMTag, HMInstructorsStack, MediaThumbnail },
  props: {
    product: {
      type: Object as () => ProductResponse,
      required: false,
    },
    media: {
      type: Object as () => ProductMediaResponse,
      required: true,
    },
  },
  filters: {
    date: function (value: string): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
  computed: {
    ...mapGetters({
      cantViewProductContentReason: 'product/cantViewProductContentReason',
      mediaIconsEnabled: 'studio/mediaIconsEnabled',
    }),
    cantViewBecauseNotPurchased() {
      return this.cantViewProductContentReason === 'not_purchased';
    },
    canViewProductContent: {
      get() {
        if (!this.product) return true;
        return this.$store.getters['product/canViewProductContent'];
      },
    },
    getCantViewProductReasonText() {
      if (!this.product) return '';
      if (this.canViewProductContent) return null;
      switch (this.cantViewProductContentReason) {
        case 'unauthenticated':
          return this.$t(
            'PRODUCTS.TEXT.PRODUCT_NO_ACCESS_USER_NOT_AUTHENTICATED'
          );
        case 'not_purchased':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_NOT_PURCHASED');
        case 'paused':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_PAUSED');
        case 'availability_expired':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_EXPIRED', {
            date: formatDate(
              this.product.can_view_content.end_date,
              'date-time'
            ),
          });
        case 'drip_expired':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_EXPIRED', {
            date: formatDate(
              this.product.can_view_content.end_date,
              'date-time'
            ),
          });
        case 'not_yet_available':
          return this.$t('PRODUCTS.TEXT.PRODUCT_NO_ACCESS_NOT_YET_AVAILABLE', {
            date: formatDate(
              this.product.can_view_content.start_date,
              'date-time'
            ),
          });
      }
      return '';
    },
    getMediaTags() {
      const mediaOptionsArray = this.media.options;
      const sortedMediaOptionsArray = mediaOptionsArray
        .sort((o1, o2) => o1.category_position - o2.category_position)
        .slice();
      return sortedMediaOptionsArray.splice(0, 2);
    },

    getCutOffMediaTagsHtml() {
      const mediaOptionsArray = this.media.options.slice();
      return mediaOptionsArray
        .splice(2)
        .map(option => option.option_name)
        .join('<br/>');
    },
    getRemainingMediaTagsText() {
      if (this.media.options.length < 3) return null;
      return `+ ${this.media.options.length - 2}`;
    },
  },
});
